import angular from 'angular';

ApplicationController.$inject = 
  ['TopToolbarFactory', '$scope', 'ApplicationsFactory', '$translate', '$stateParams', 'application', 'AlertingFactory', 'sites', 'DropdownItemsFactory'];
export function ApplicationController(
  TopToolbarFactory, $scope, ApplicationsFactory, $translate, $stateParams, application, AlertingFactory, sites, DropdownItemsFactory) {

  init();
  $scope.save = save;
  $scope.onModelChange = onModelChange;


  function save() {
    ApplicationsFactory.updateApplication($stateParams.companyId, $scope.application)
      .then(() => {
          AlertingFactory.success('parameters/applications/save_ok');
          onModelPristine();
        },
        () => AlertingFactory.error('parameters/applications/save_ko'));
  }


  function onModelChange() {
    $scope.modelHasChanged.value = true;
    const webhook_permission = $scope.application.permissions.find(permission => permission.name === 'webhook');
    if (webhook_permission && webhook_permission.is_active && (!webhook_permission.data.notification_email || !webhook_permission.data.url)) {
      $scope.modelHasChanged.value = false;
    }
  }

  function onModelPristine() {
    $scope.modelHasChanged = {
      'value': false
    };
  }

  function initPermission(permission) {
    permission.label = $translate.instant(`parameters/applications/${permission.name}_permission`);
    permission.tooltip = $translate.instant(`parameters/applications/${permission.name}_permission_tooltip`);
    if (permission.name === 'webhook') {
      permission.data.site_ids = permission.data.site_ids ? permission.data.site_ids : [];
      permission.data.action_types = permission.data.action_types ? permission.data.action_types : [];
      permission.data.enable_attachments_in_payload = !!permission.data.enable_attachments_in_payload;
    }
  }

  function init() {
    $scope.$watch('survey.name', newValue => TopToolbarFactory.setTitle(newValue, $scope));
    TopToolbarFactory.setButton('save', save, $scope);
    $scope.$watch('surveyForm.$invalid || !modelHasChanged.value', 
                  newValue => TopToolbarFactory.updateButtonDisable(newValue, $scope));
    onModelPristine();
    application.permissions.forEach(permission => initPermission(permission));
    $scope.application = application;
    $scope.siteDropdownItems = DropdownItemsFactory.buildSiteItems(sites, true);
    $scope.actionTypeDropdownItems = DropdownItemsFactory.buildActionTypeItems();
  }

}
